export default __webpack_public_path__ + "static/media/barrique-243x279.fcda1264.svg";